<template>

  <!-- the account status (slot) on the left; on wide screens the menu import sits to its right -->
  <div class="account-header">

    <div class="account-section">
      <slot />
    </div>

    <!-- AI menu import: opens the single-page creator with upload -->
    <div class="import-menu" v-if="show_import">
      <div class="import-menu-button" role="button" tabindex="0" @click="importMenu()" @keydown.enter="importMenu()">
        <i class="pi pi-upload"></i>
        <span>Auto-import menu</span>
      </div>
      <router-link to="/ai_jobs" class="ai-jobs-link">
        Auto-import and translation jobs<span class="ai-jobs-count" v-if="open_jobs > 0">{{ open_jobs }} running or ready</span>
      </router-link>
      <p class="import-menu-summary">Import your menu from a PDF or photos (JPG, PNG or WebP) and automatically generate a digital version. Auto-translation is supported after the initial menu is created.</p>
    </div>

  </div>

</template>


<script>
// Used by the dashboard and the My menus page.
export default {
  name: 'AccountHeaderWithImport',
  props: {
    show_import: { type: Boolean, default: false }
  },
  data() {
    return {
      open_jobs: 0
    }
  },
  watch: {
    // shown once the page knows the user can create menus
    show_import: {
      immediate: true,
      handler(shown) {
        if (shown) {
          this.loadOpenJobs()
        }
      }
    }
  },
  methods: {
    // how many AI runs are still running or waiting for review, for the AI jobs link
    loadOpenJobs() {
      this.$http.secured.get('/app_ai_jobs', { params: { unresolved: 1 } })
        .then(response => { this.open_jobs = response.data.jobs.length })
        .catch(() => { this.open_jobs = 0 })
    },
    importMenu() {
      this.$router.push('/create_menu')
    }
  }
}
</script>


<style scoped>

.account-header {
  width: 95%;
  margin: 0px auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  position: relative;
  z-index: 1;
}

.account-section {
  flex: 1;
  min-width: 0;
}

/* the account pieces size themselves against the whole page; inside the column they shouldn't */
.account-section ::v-deep #account-status {
  width: 100%;
}

.account-section ::v-deep .account-info {
  margin-left: 0px;
}

.import-menu {
  flex-shrink: 0;
  max-width: 460px;
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-end; /* button and summary against the right edge on wide screens */
  text-align: right;
}

.import-menu-button {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 14px;
  background-color: #111111;
  color: white;
  font-size: 22px;
  font-weight: 600;
  padding: 20px 40px;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.15s, box-shadow 0.15s;
}

.import-menu-button:hover {
  transform: translateY(-2px);
  background-color: #000000;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.25);
}

.import-menu-button i {
  font-size: 22px;
}

.ai-jobs-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  font-size: 13px;
  font-weight: 600;
  color: #111111;
  text-decoration: underline;
}

.ai-jobs-count {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 999px;
  background-color: #39B54A;
  color: white;
  text-decoration: none;
}

.import-menu-summary {
  font-size: 14px;
  color: #505050;
  line-height: 1.6;
  margin: 15px 0px 0px 0px;
}

@media(max-width: 900px) {
  .account-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0px;
  }

  .import-menu {
    max-width: none;
    padding-top: 30px;
    align-items: flex-start;
    text-align: left;
  }
}

@media(max-width: 600px) {
  .import-menu {
    width: 100%;
  }

  .import-menu-button {
    display: flex;
    justify-content: center;
    font-size: 18px;
    padding: 16px 20px;
  }
}

</style>
